module.exports = __webpack_public_path__ + "img/tips-normal.d29cd55d.svg";